import {Navigate, Outlet, Route, Routes} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import {MaDinhDanhListWrapper} from './madinhdanh/MaDinhDanhList'
const MaDinhDanhBreadcrumbs: Array<PageLink> = [
  {
    title: 'Trang chủ',
    path: '/',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
  {
    title: 'Quản trị hệ thống',
    path: '#',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
  {
    title: 'Danh mục',
    path: '#',
    isSeparator: false,
    isActive: false,
  },
]

const MaDinhDanhPage = () => {
  document.title = 'Mã định danh'
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='danhsach'
          element={
            <>
              <PageTitle breadcrumbs={MaDinhDanhBreadcrumbs}></PageTitle>
              <MaDinhDanhListWrapper />
            </>
          }
        />
      </Route>

      <Route index element={<Navigate to='/quantrihethong/danhmuc/madinhdanh/danhsach' />} />
    </Routes>
  )
}

export default MaDinhDanhPage
